var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.421,
    height: 16.029,
    viewBox: "0 0 9.421 16.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ec6321;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.708,23.7a1.362,1.362,0,0,0,0,1.92,1.34,1.34,0,0,0,.956.394,1.364,1.364,0,0,0,.963-.4l6.609-6.63a1.355,1.355,0,0,0-.042-1.87l-6.708-6.729a1.357,1.357,0,0,0-1.92,1.92L18.326,18Z",
    transform: "translate(-12.169 -9.987)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveArrow);
export default __webpack_public_path__ + "static/media/activeArrow.bd7809a6a2113e3143418e353943d56b.svg";
export { ForwardRef as ReactComponent };